import type { MftpDirectoryService } from '@singular-health/services';
import { inject } from 'vue';
import { MFTP_DIRECTORY_SERVICE_KEY } from '../keys';

export function useMftpDirectoryService(): MftpDirectoryService {
  const service = inject(MFTP_DIRECTORY_SERVICE_KEY);
  if (!service) throw new Error('[mftp] useMftpDirectoryService() requires the Mftp plugin to be installed.');
  return service;
}
